const wavePointMixin = {
  data() {
    return {
      mpoint: [],
      originalTrendInfo: null,  // 保存原始 trendInfo 数据，用于多测点处理
      originalFeature: null,    // 保存原始 feature，用于多测点处理
      wavePointState: {
        isMark: false,
        enabled: true,  // 是否启用波形点功能
        icon: "M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z"
      },
    };
  },
  methods: {
    // 设置是否启用波形点功能
    setWavePointEnabled(enabled) {
      this.wavePointState.enabled = enabled;
    },

    setHighLightPoint(dataX, dataY, mpoint) {
      if (mpoint && mpoint.length) {
        this.mpoint = mpoint;
      }
    },

    /**
     * 从原始趋势数据中提取波形点并保存
     * 调用方式：this.setWavePointData(trendInfo, feature)
     * trendInfo: 趋势数据数组，每个元素包含 smpNum、trendTime、trendValue 等字段
     * feature: 当前选中的特征值字段名（如 'all', 'one', 'two' 等）
     */
    setWavePointData(trendInfo, feature) {
      if (!trendInfo || trendInfo.length === 0) return;
      if (!this.mychart) return;

      // 检查 feature 是否有效，如果没有 feature 则不显示波形点功能
      if (!feature || (typeof feature === 'string' && !feature.trim())) {
        this.wavePointState.enabled = false;
        return;
      }

      // 启用波形点功能
      this.wavePointState.enabled = true;

      // 保存原始数据，支持多测点处理
      this.originalTrendInfo = trendInfo;
      this.originalFeature = feature;
      this.originalIndexMap = null;  // 重置索引映射

      // 自动应用波形点标记（如果当前标记状态是开启的）
      if (this.wavePointState.isMark) {
        this.applyWavePointMark();
      }

      let chartData = this.mychart.getOption().series;
      let seriesCount = chartData ? chartData.length : 0;

      if (seriesCount === 0) return;

      // 支持传入单个 feature 或 feature 数组（多特征值）
      let featureList = [];
      if (Array.isArray(feature)) {
        featureList = feature;
      } else if (feature) {
        featureList = [feature];
      }

      let mpoint = [];

      // 处理 indexMap（如果有）- 默认使用 series 索引
      let getIndex = null;
      let indexMap = this.originalIndexMap;
      if (typeof indexMap === 'function') {
        getIndex = indexMap;
      } else if (Array.isArray(indexMap)) {
        getIndex = (i) => indexMap[i] !== undefined ? indexMap[i] : 0;
      } else {
        getIndex = (i) => i;
      }

      for (let i = 0; i < seriesCount; i++) {
        let channelWavePoints = [];
        // 获取当前 series 对应的 feature
        let currentFeature = featureList[i] || featureList[0];
        let trendValueIndex = getIndex(i);

        for (let j = 0; j < trendInfo.length; j++) {
          if (trendInfo[j].smpNum && trendInfo[j].smpNum > 0) {
            // 使用自定义索引获取数据
            let yValue = trendInfo[j].trendValue[trendValueIndex];
            if (!yValue) continue;

            let value = null;
            if (currentFeature) {
              value = yValue[currentFeature];
            }

            if (value !== null && value !== undefined) {
              channelWavePoints.push({
                xAxis: this.formatTimestamp(trendInfo[j].trendTime),
                yAxis: value,
                symbol: 'emptyCircle',
                symbolSize: 5,
                itemStyle: {
                  color: this.$store.state.colorMap[i],
                },
              });
            }
          }
        }
        mpoint.push(channelWavePoints);
      }

      this.mpoint = mpoint;

      // 如果标记状态是开启的，自动重新显示波形点
      if (this.wavePointState.isMark) {
        this.applyWavePointMark();
      }
    },

    /**
     * 多特征值模式：从原始趋势数据中提取所有特征值的波形点
     * 调用方式：this.setWavePointDataMulti(trendInfo, features, seriesNames, indexMap)
     * trendInfo: 趋势数据数组
     * features: 特征值数组，如 ['all', 'one', 'two']
     * seriesNames: series 名称数组，用于匹配对应的 feature
     * indexMap: 可选，索引映射，用于指定使用 trendValue 的哪个索引
     */
    setWavePointDataMulti(trendInfo, features, seriesNames, indexMap) {
      if (!trendInfo || trendInfo.length === 0) return;
      if (!this.mychart) return;
      if (!features || features.length === 0) return;

      // 启用波形点功能
      this.wavePointState.enabled = true;

      // 保存原始数据，支持多测点处理
      this.originalTrendInfo = trendInfo;
      this.originalFeature = features;
      this.originalIndexMap = indexMap || null;  // 保存索引映射

      // 自动应用波形点标记（如果当前标记状态是开启的）
      if (this.wavePointState.isMark) {
        this.applyWavePointMark();
      }

      let chartData = this.mychart.getOption().series;
      let seriesCount = chartData ? chartData.length : 0;

      if (seriesCount === 0) return;

      // 处理 indexMap（如果有）
      let getIndex = null;
      let indexMapSource = this.originalIndexMap;
      if (typeof indexMapSource === 'function') {
        getIndex = indexMapSource;
      } else if (Array.isArray(indexMapSource)) {
        getIndex = (i) => indexMapSource[i] !== undefined ? indexMapSource[i] : 0;
      } else {
        getIndex = (i) => i;
      }

      let mpoint = [];

      // 为每个 series 提取对应特征值的波形点
      for (let i = 0; i < seriesCount; i++) {
        let channelWavePoints = [];
        // 获取当前 series 名称
        let seriesName = chartData[i].name;
        // 找到对应的 feature - 根据索引匹配
        let currentFeature = features[i] || features[0];
        let trendValueIndex = getIndex(i);

        for (let j = 0; j < trendInfo.length; j++) {
          if (trendInfo[j].smpNum && trendInfo[j].smpNum > 0) {
            // 使用自定义索引获取数据
            let yValue = trendInfo[j].trendValue[trendValueIndex];
            if (!yValue) continue;

            let value = null;
            if (currentFeature) {
              value = yValue[currentFeature];
            }

            if (value !== null && value !== undefined) {
              channelWavePoints.push({
                xAxis: this.formatTimestamp(trendInfo[j].trendTime),
                yAxis: value,
                symbol: 'emptyCircle',
                symbolSize: 5,
                itemStyle: {
                  color: this.$store.state.colorMap[i],
                },
              });
            }
          }
        }
        mpoint.push(channelWavePoints);
      }

      this.mpoint = mpoint;

      // 如果标记状态是开启的，自动重新显示波形点
      if (this.wavePointState.isMark) {
        this.applyWavePointMark();
      }
    },
    /**
     * 简化版：直接使用嵌套的 trendValue 字段（不需要 feature 匹配）
     * 适用于 ReciprocatAlarmQuery 等组件
     * 调用方式：this.setWavePointDataSimple(trendInfo, indexMap)
     * trendInfo: 趋势数据数组
     * indexMap: 索引映射数组，如 [0, 1] 或 [0]
     */
    setWavePointDataSimple(trendInfo, indexMap) {
      if (!trendInfo || trendInfo.length === 0) return;
      if (!this.mychart) return;

      // 启用波形点功能
      this.wavePointState.enabled = true;

      // 保存原始数据
      this.originalTrendInfo = trendInfo;
      this.originalIndexMap = indexMap;

      // 覆盖 toggleWavePoint 方法，使其调用简化版
      this._originalToggleWavePoint = this.toggleWavePoint;
      this.toggleWavePoint = () => {
        this.wavePointState.isMark = !this.wavePointState.isMark;
        this.applySimpleWavePointMark(this.originalTrendInfo, this.originalIndexMap);
      };

      // 直接提取波形点数据并应用到图表
      this.applySimpleWavePointMark(trendInfo, indexMap);
    },

    // 简化版：直接使用嵌套的 trendValue 字段
    applySimpleWavePointMark(trendInfo, indexMap) {
      const chart = this.mychart;
      const op = chart.getOption();

      if (!op.series || op.series.length === 0) return;

      // 处理 indexMap
      let getIndex = null;
      if (typeof indexMap === 'function') {
        getIndex = indexMap;
      } else if (Array.isArray(indexMap)) {
        getIndex = (i) => indexMap[i] !== undefined ? indexMap[i] : 0;
      } else {
        getIndex = (i) => i;
      }

      let option = {
        series: []
      };

      for (let i = 0; i < op.series.length; i++) {
        let series = op.series[i];
        let wavePoints = [];

        if (this.wavePointState.isMark && trendInfo && trendInfo.length > 0) {
          let trendValueIndex = getIndex(i);

          // 直接使用嵌套的 trendValue 字段
          for (let j = 0; j < trendInfo.length; j++) {
            if (trendInfo[j].smpNum && trendInfo[j].smpNum > 0) {
              let yValue = trendInfo[j].trendValue[trendValueIndex];
              if (!yValue) continue;

              let value = yValue.trendValue;
              if (value !== null && value !== undefined) {
                wavePoints.push({
                  xAxis: this.formatTimestamp(trendInfo[j].trendTime),
                  yAxis: value,
                  symbol: 'emptyCircle',
                  symbolSize: 5,
                  itemStyle: {
                    color: this.$store.state.colorMap[i],
                  },
                });
              }
            }
          }
        }

        if (wavePoints.length > 0) {
          // 保留已有的标记点
          let existingData = series.markPoint && series.markPoint.data ? series.markPoint.data : [];

          const preserveNames = ['主游标点', '辅游标点', '标点'];
          existingData = existingData.filter(item =>
            preserveNames.includes(item.name) || (item.value !== undefined && !item.name)
          );

          // 保留原有的 markPoint 样式配置
          const existingMarkPoint = series.markPoint || {};
          series.markPoint = {
            ...existingMarkPoint,
            name: "显示波形点",
            data: [...existingData, ...wavePoints],
          };
        } else {
          // 只清空波形点
          if (series.markPoint && series.markPoint.data) {
            const preserveNames = ['主游标点', '辅游标点', '标点'];
            series.markPoint.data = series.markPoint.data.filter(item =>
              preserveNames.includes(item.name) || (item.value !== undefined && !item.name)
            );
          } else {
            series.markPoint = null;
          }
        }
        option.series.push(series);
      }

      chart.setOption(option);
    },

    getWavePointTitle() {
      return this.wavePointState.isMark ? "取消标记波形点" : "标记波形点";
    },

    /**
     * 多测点模式：每个 series 有独立的 trendInfo 数组
     * 调用方式：this.setWavePointDataForMultipoint(trendInfoArray, features)
     * trendInfoArray: 每个 series 对应的 trendInfo 数组，如 [测点1的trendInfo, 测点2的trendInfo, ...]
     * features: 每个 series 对应的 feature 数组，如 ['all', 'all', ...]
     */
    setWavePointDataForMultipoint(trendInfoArray, features) {
      if (!trendInfoArray || !Array.isArray(trendInfoArray) || trendInfoArray.length === 0) return;
      if (!this.mychart) return;

      // 启用波形点功能
      this.wavePointState.enabled = true;

      // 为每个 series 提取波形点数据
      let mpoint = [];
      let seriesCount = trendInfoArray.length;

      for (let i = 0; i < seriesCount; i++) {
        let trendInfo = trendInfoArray[i];
        let feature = features[i] || features[0];
        let channelWavePoints = [];

        if (trendInfo && trendInfo.length > 0) {
          for (let j = 0; j < trendInfo.length; j++) {
            if (trendInfo[j].smpNum && trendInfo[j].smpNum > 0) {
              let yValue = trendInfo[j].trendValue[0];  // 每个测点只有1个通道
              if (!yValue) continue;

              let value = yValue[feature];
              if (value !== null && value !== undefined) {
                channelWavePoints.push({
                  xAxis: this.formatTimestamp(trendInfo[j].trendTime),
                  yAxis: value,
                  symbol: 'emptyCircle',
                  symbolSize: 5,
                  itemStyle: {
                    color: this.$store.state.colorMap[i],
                  },
                });
              }
            }
          }
        }

        mpoint.push(channelWavePoints);
      }

      this.mpoint = mpoint;
      this.mpointSeriesCount = seriesCount;

      // 覆盖 toggleWavePoint 方法
      this._originalToggleWavePoint = this.toggleWavePoint;
      this.toggleWavePoint = () => {
        this.wavePointState.isMark = !this.wavePointState.isMark;
        this.applyWavePointMarkForMultipoint();
      };
    },

    // 多测点模式：应用波形点标记
    applyWavePointMarkForMultipoint() {
      const chart = this.mychart;
      const op = chart.getOption();

      if (!op.series || op.series.length === 0) return;

      for (let i = 0; i < op.series.length; i++) {
        let series = op.series[i];

        if (this.wavePointState.isMark) {
          let wavePoints = this.mpoint[i] || [];
          if (wavePoints.length > 0) {
            // 保留已有的标记点
            let existingData = series.markPoint && series.markPoint.data ? series.markPoint.data : [];
            const preserveNames = ['主游标点', '辅游标点', '标点'];
            existingData = existingData.filter(item =>
              preserveNames.includes(item.name) || (item.value !== undefined && !item.name)
            );
            const existingMarkPoint = series.markPoint || {};
            series.markPoint = {
              ...existingMarkPoint,
              name: "显示波形点",
              data: [...existingData, ...wavePoints],
            };
          } else {
            if (series.markPoint && series.markPoint.data) {
              const preserveNames = ['主游标点', '辅游标点', '标点'];
              series.markPoint.data = series.markPoint.data.filter(item =>
                preserveNames.includes(item.name) || (item.value !== undefined && !item.name)
              );
            } else {
              series.markPoint = undefined;
            }
          }
        } else {
          if (series.markPoint && series.markPoint.data) {
            const preserveNames = ['主游标点', '辅游标点', '标点'];
            series.markPoint.data = series.markPoint.data.filter(item =>
              preserveNames.includes(item.name) || (item.value !== undefined && !item.name)
            );
          } else {
            series.markPoint = undefined;
          }
        }
      }

      chart.setOption({
        series: op.series
      }, {
        replaceMerge: []
      });
    },

    toggleWavePoint() {
      this.wavePointState.isMark = !this.wavePointState.isMark;

      this.applyWavePointMark();
    },

    // 应用波形点标记（不切换状态）- 支持多测点，套用标点功能逻辑
    applyWavePointMark() {
      const chart = this.mychart;
      const op = chart.getOption();

      if (!op.series || op.series.length === 0) return;

      let option = {
        series: []
      };

      // 处理 indexMap（如果有）
      let getIndex = null;
      let indexMap = this.originalIndexMap;
      if (typeof indexMap === 'function') {
        getIndex = indexMap;
      } else if (Array.isArray(indexMap)) {
        getIndex = (i) => indexMap[i] !== undefined ? indexMap[i] : 0;
      } else {
        getIndex = (i) => i;  // 默认使用 series 索引
      }

      // 遍历所有 series，类似标点功能 myMarkPointFun 的处理方式
      for (let i = 0; i < op.series.length; i++) {
        let series = op.series[i];
        let wavePoints = [];

        // 如果标记状态开启，从原始数据中提取波形点
        if (this.wavePointState.isMark) {
          let trendInfo = this.originalTrendInfo;
          let feature = this.originalFeature;

          if (trendInfo && trendInfo.length > 0) {
            // 使用自定义索引获取数据
            let trendValueIndex = getIndex(i);

            // 从 trendInfo 中提取波形点（smpNum > 0）
            for (let j = 0; j < trendInfo.length; j++) {
              if (trendInfo[j].smpNum && trendInfo[j].smpNum > 0) {
                let yValue = trendInfo[j].trendValue[trendValueIndex];
                if (!yValue) continue;

                let value = null;
                if (feature) {
                  // 普通版：确定当前 series 对应的 feature
                  let featureList = [];
                  if (Array.isArray(feature)) {
                    featureList = feature;
                  } else if (feature) {
                    featureList = [feature];
                  }
                  let currentFeature = featureList[i] || featureList[0];
                  value = yValue[currentFeature];
                }

                if (value !== null && value !== undefined) {
                  wavePoints.push({
                    xAxis: this.formatTimestamp(trendInfo[j].trendTime),
                    yAxis: value,
                    symbol: 'emptyCircle',
                    symbolSize: 5,
                    itemStyle: {
                      color: this.$store.state.colorMap[i],
                    },
                  });
                }
              }
            }
          } else {
            // 如果没有原始数据，回退到使用预存储的 mpoint
            if (this.mpoint[i] && this.mpoint[i].length > 0) {
              wavePoints = this.mpoint[i];
            }
          }
        }

        if (wavePoints.length > 0) {
          // 保留已有的标记点
          let existingData = series.markPoint && series.markPoint.data ? series.markPoint.data : [];

          const preserveNames = ['主游标点', '辅游标点', '标点'];
          existingData = existingData.filter(item =>
            preserveNames.includes(item.name) || (item.value !== undefined && !item.name)
          );

          const existingMarkPoint = series.markPoint || {};
          series.markPoint = {
            ...existingMarkPoint,
            name: "显示波形点",
            data: [...existingData, ...wavePoints],
          };
        } else {
          if (series.markPoint && series.markPoint.data) {
            const preserveNames = ['主游标点', '辅游标点', '标点'];
            series.markPoint.data = series.markPoint.data.filter(item =>
              preserveNames.includes(item.name) || (item.value !== undefined && !item.name)
            );
          } else {
            series.markPoint = {
              data: []
            };
          }
        }

        option.series.push(series);
      }

      this.mychart.setOption(option, { notMerge: false });
    },

    getMarkWavePoint() {
      let currentPath = this.$route ? this.$route.path : '';

      const disabledRoutes = [
        '/ReciprocatMachineryGraph/OtherParametersTrend1',
        '/gasTurbineGraph/GasOverviewGrap',
        '/gasTurbineGraph/AlarmQueryGraph2',
        '/gasTurbineGraph/GasVibrationMonitor',
        '/gasTurbineGraph/VibrationHistoricalComparison',
        '/gasTurbineGraph/OrbitOfShaftCenter1',
        '/gasTurbineGraph/AxisPosition',
        '/gasTurbineGraph/StartStopGraph'
      ];

      if (disabledRoutes.some(route => currentPath === route)) {
        return {};
      }

      // 如果未启用波形点功能，不显示按钮
      if (!this.wavePointState.enabled) {
        return {};
      }
      let self = this;
      return {
        myMarkWavePoint: {
          title: self.getWavePointTitle(),
          icon: self.wavePointState.icon,
          show: false,
          onclick: function() {
            self.toggleWavePoint();
            let option = {
              toolbox: {
                feature: {
                  myMarkWavePoint: {
                    title: self.getWavePointTitle(),
                  }
                }
              }
            };
            self.mychart.setOption(option);
          }
        }
      };
    },
  },
};

export default wavePointMixin;



// WEBPACK FOOTER //
// ./src/mixins/wavePointMixin.js